import * as React from 'react';

const LogoEBurstSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 61 61" {...props}>
        <defs>
            <circle id="logo-e-burst_svg__c" cx={30.5} cy={30.5} r={28.5} />
            <circle id="logo-e-burst_svg__f" cx={30.5} cy={30.5} r={28.5} />
            <path id="logo-e-burst_svg__a" d="M0 0h61v61H0z" />
            <path id="logo-e-burst_svg__d" d="M0 0h61v61H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="logo-e-burst_svg__b" fill="#fff">
                <use xlinkHref="#logo-e-burst_svg__a" />
            </mask>
            <path
                d="M30.5 59C46.24 59 59 46.24 59 30.5S46.24 2 30.5 2 2 14.76 2 30.5 14.76 59 30.5 59z"
                stroke="#F6682F"
                strokeWidth={4}
                strokeDasharray="1,2.5"
                mask="url(#logo-e-burst_svg__b)"
            />
            <g>
                <mask id="logo-e-burst_svg__e" fill="#fff">
                    <use xlinkHref="#logo-e-burst_svg__d" />
                </mask>
                <path
                    d="M30.5 59C46.24 59 59 46.24 59 30.5S46.24 2 30.5 2 2 14.76 2 30.5 14.76 59 30.5 59z"
                    stroke="#F6682F"
                    strokeWidth={4}
                    strokeDasharray="1,2.5"
                    mask="url(#logo-e-burst_svg__e)"
                />
            </g>
            <path
                d="M28.756 22.215c3.62-.784 7.233.636 9.244 3.322L22 29c.552-3.24 3.135-6.002 6.756-6.785zM37.9 35.192c-1.22 1.697-3.098 2.98-5.39 3.477-3.671.796-7.335-.662-9.354-3.407l16.172-3.507 2.635-.571L47 30.092a14.688 14.688 0 00-.42-3.078c-2.05-8.34-10.91-13.539-19.788-11.613-8.88 1.925-14.415 10.246-12.365 18.585 2.05 8.34 10.91 13.539 19.788 11.613 5.232-1.134 9.302-4.49 11.344-8.76L37.9 35.192z"
                fill="#F6682F"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

LogoEBurstSvg.displayName = 'LogoEBurstSvg';
export default LogoEBurstSvg;
